<template>
    <DCard
        :title="
            __('messages.dashboard.widgets.customers_per_brand.title') + ' - ' + __('messages.dashboard.widgets.customers_per_brand.description')"
        class="height widget p-3 card"
    >
        <DRow class="mt-3">
            <DCol
                sm="3"
                class="user-dropdown"
            >
                <DSelect
                    id="status-dropdown"
                    :options="chartTypeOptions"
                    :model-value="chartType"
                    @update:value="updateChartType"
                />
            </DCol>
        </DRow>
        <CChart
            v-if="chartType === 'bar'"
            id="customers-per-brand-bar"
            type="bar"
            :data="data"
            :custom-tooltips="false"
            :options="barOptions"
            class="p-3"
            height="250"
        />
        <CChart
            v-if="chartType === 'pie'"
            id="customers-per-brand-pie"
            type="pie"
            :data="data"
            class="p-3"
            :options="pieOptions"
            :height="400"
        />
    </DCard>
</template>

<script setup>
import { CChart } from '@coreui/vue-chartjs'
import { ref, onMounted, computed } from 'vue'
import { route } from '~@/Composables/route'

import { __ } from '~@/Composables/translation'

const data = ref({})
const chartType = ref('bar')

onMounted(async () => {
    window.axios.get(route('widgets.get-data'), {
        params: {
            widget: 'customers_per_brand'
        }
    })
        .then(function (response) {
            data.value = buildDataSet(response.data)
        })
})

const barOptions = ref({
    onHover: (event, chartElement) => {
        event.native.target.style.height = '250px'
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
    },
    maintainAspectRatio: false,
    scales: {
        x: {
            grid: {
                display: false
            }
        },
        y: {
            type: 'logarithmic',
            grid: {
                display: false
            },
            ticks: {
                format: { maximumSignificantDigits: 1 }
            }
        }
    },
    plugins: {
        legend: {
            display: false
        }
    }
})

const pieOptions = ref({
    onHover: (event, chartElement) => {
        event.native.target.style.height = '400px'
        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
    },
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: true
        }
    }
})

function buildDataSet (response) {
    return {
        labels: response.data.labels ?? [],
        datasets: [
            {
                data: response.data.data,
                backgroundColor: ['#08aad2', '#fe6e73', '#d63f38', '#69ae34', '#dfb52c', '#f89256', '#7d8998'],
                maxBarThickness: 200,
                borderWidth: 0
            }
        ]
    }
}

const chartTypeOptions = computed(() => [
    {
        label: __('messages.dashboard.widgets.customers_per_brand.bar_chart'),
        value: 'bar'
    },
    {
        label: __('messages.dashboard.widgets.customers_per_brand.pie_chart'),
        value: 'pie'
    }
])

function updateChartType (value) {
    chartType.value = value
}
</script>
<style>
</style>
